import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvEventValueObject} from "../../../data/value-object/env/EnvEventValueObject";
import {EnvEventSearchOption} from "../../../data/search-option/env/EnvEventSearchOption";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvEventIO} from "../../../io/EnvIO";
import {EnvEventDescription} from "../../../data/description/env/EnvEventDescription";
import {EnvEventDescriptor} from "../../../data/descriptor/env/EnvEventDescriptor";
import ListOption from "../../ListOption";
import {EnvEventSearchOptionDescription} from "../../../data/description/env/EnvEventSearchOptionDescription";
import {
    applyEnvEventSearchOption,
    EnvEventSearchOptionField
} from "../../search-option-field/env/EnvEventSearchOptionField";
import ListOrder from "../../ListOrder";
import {SearchIndex} from "../../../io/HttpClient";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvEventValueObject[]>([])
    const option = useStatePair<EnvEventSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvEventIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvEventDescription}
                descriptor={EnvEventDescriptor}
                showPost
                onPostClick={() => document.location = '/env/events/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/events/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvEventSearchOptionDescription}
                fields={EnvEventSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvEventSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvEventDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}